import React, { MouseEvent } from 'react';
import InputGroup from '../../../../../components/form/InputGroup';
import SelectCarColor from '../../../../../components/form/selects/SelectCarColor';
import SelectCarMaker from '../../../../../components/form/selects/SelectCarMaker';
import InputTextArea from '../../../../../components/form/InputTextArea';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import OwnershipCarType from '../../../../../types/ownershipCar.type';
import SelectVehicleGroup from '../../../../../components/form/selects/SelectVehicleGroup';
import { useGetUpdateVehiclePermitModalData, 
    useSetUpdateVehiclePermitValueForm } from '../../../../../stores/updateVehiclePermitModal.store';
import useUpdateVehicleModalFunctions from '../../../../../hooks/useUpdateVehicleModalFunctions';



const UpdateVehicleForm = () => {

    const setValueForm = useSetUpdateVehiclePermitValueForm();
    const updateVehicleModalData = useGetUpdateVehiclePermitModalData();
    const { handleBlur, handleOnChange, handleOnChangeFile } = useUpdateVehicleModalFunctions();

    const {values, errors, touched} = updateVehicleModalData.form;

    const commentLabel = 'הערה';

    const carIdLabel = 'מספר רכב';
    const ownershipCarLabel = 'בעלות רכב';
    const privateCarLabel = 'רכב פרטי';
    const companyCarLabel = 'רכב חברה';
    const scanCarIdLabel = 'צילום רשיון רכב(שים לב לא רשיון נהיגה!)';
    const scanWorkStatementLabel = 'צילום הצהרה ממקום העבודה/מחברת הליסינג';

    const showWorkStatementFile = values.ownershipCar === OwnershipCarType.COMPANY;

    if (updateVehicleModalData.modalStep !== 'form') {
        return null;
    }

    return (
        <div>
            <div className='row'>
                <div className='col-12 col-sm-6'>
                    <InputGroup
                        isRequired
                        name='newVehicleNum'
                        label={carIdLabel}
                        value={values.newVehicleNum}
                        handleChange={handleOnChange}
                        handleBlur={handleBlur}
                        errorMsg={(errors.newVehicleNum && touched.newVehicleNum) && errors.newVehicleNum}
                    />
                </div>
                <div className='col-12 col-sm-6'>

                    <RadioBtnsContainer label={ownershipCarLabel}>
                        <RadioOutlineBtn
                            isChecked={values.ownershipCar === OwnershipCarType.PRIVATE}
                            label={privateCarLabel}
                            value={OwnershipCarType.PRIVATE}
                            onClick={() => setValueForm('ownershipCar', OwnershipCarType.PRIVATE)}
                            id="isCompanyYes"
                            name='ownershipCar'
                        />
                        <RadioOutlineBtn
                            isChecked={values.ownershipCar === OwnershipCarType.COMPANY}
                            label={companyCarLabel}
                            value={OwnershipCarType.COMPANY}
                            onClick={() => setValueForm('ownershipCar', OwnershipCarType.COMPANY)}
                            id="isCompanyNo"
                            name='ownershipCar'
                        />
                    </RadioBtnsContainer>
                </div>
            </div>

            <div className='row mb-2'>
                <div className='col-12 col-sm-6'>
                    <SelectCarColor
                        name={'newColorId'}
                        value={values.newColorId}
                        onChange={(name, newValue) => setValueForm('newColorId', newValue)}
                        onBlur={handleBlur}
                        errorMsg={(errors.newColorId && touched.newColorId) ? errors.newColorId : undefined}
                    />
                </div>
                <div className='col-12 col-sm-6'>

                    <SelectCarMaker
                        name={'newTypeId'}
                        value={values.newTypeId}
                        onChange={(name, newValue) => setValueForm('newTypeId', newValue)}
                        onBlur={handleBlur}
                        errorMsg={(errors.newTypeId && touched.newTypeId) ? errors.newTypeId : undefined}
                    />
                </div>

                <div className='col-12 col-sm-6'>

                    <SelectVehicleGroup
                        name={'newVehicleGroupId'}
                        value={values.newVehicleGroupId}
                        onChange={(name, newValue) => setValueForm('newVehicleGroupId', newValue)}
                        onBlur={handleBlur}
                        errorMsg={(errors.newVehicleGroupId && touched.newVehicleGroupId) ? errors.newVehicleGroupId : undefined}
                    />
                </div>
            </div>

            <div className='row mb-2'>
                <div className='col-12'>
                    <InputTextArea
                        handleBlur={handleBlur}
                        handleChange={handleOnChange}
                        value={values.citizenComment}
                        name='citizenComment'
                        label={commentLabel}
                        required={false}
                    />
                </div>
            </div>

            <div className='row mb-4'>
                <div className='col-12'>
                    <InputGroup
                        isRequired
                        label={scanCarIdLabel}
                        handleChange={handleOnChangeFile}
                        handleBlur={handleBlur}
                        type='file'
                        name='scanCarId'
                        //@ts-ignore
                        errorMsg={(errors.scanCarId && touched.scanCarId) ? errors.scanCarId : undefined}
                    />
                </div>
                {showWorkStatementFile && (
                    <div className='col-12'>
                        <InputGroup
                            isRequired
                            label={scanWorkStatementLabel}
                            handleChange={handleOnChangeFile}
                            handleBlur={handleBlur}
                            type='file'
                            name='scanWorkStatment'
                            //@ts-ignore
                            errorMsg={(errors.scanWorkStatment && touched.scanWorkStatment) ? errors.scanWorkStatment : undefined}
                        />
                    </div>
                )}

            </div>

        </div>
    );

}

export default UpdateVehicleForm;